"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var initializeExperimentState = function (defaultBucket, buckets, previousValues) { return (__assign(__assign({}, previousValues), { defaultBucket: defaultBucket || (previousValues === null || previousValues === void 0 ? void 0 : previousValues.defaultBucket) || 'control', buckets: __spreadArray([], Array.from(new Set(((previousValues === null || previousValues === void 0 ? void 0 : previousValues.buckets) || []).concat(__spreadArray(__spreadArray([], buckets), ['control']))))) })); };
exports.default = initializeExperimentState;
